export default __webpack_public_path__ + "static/media/MagnifyingGlass.82c3a339.svg";